const numberNotNeedingPadding = 10;
const secondsInHour = 3600;
const secondsInMinute = 60;

const padZero = (num: number): string => num >= numberNotNeedingPadding ? `${num}` : `0${num}`;

const formatTime = (totalSeconds: number): string => {
   const negative = totalSeconds < 0 ? '-' : '';
   const roundedTotalSeconds = negative ? Math.round(totalSeconds * -1) : Math.round(totalSeconds);
   const hoursPlace = Math.floor(roundedTotalSeconds / secondsInHour);
   const secondsWithoutHours = roundedTotalSeconds % secondsInHour;
   const minutesPlace = Math.floor(secondsWithoutHours / secondsInMinute);
   const secondsPlace = secondsWithoutHours % secondsInMinute;

   if (hoursPlace > 0) {
      return `${negative}${hoursPlace}:${padZero(minutesPlace)}:${padZero(secondsPlace)}`;
   } else if (minutesPlace > 0) {
      return `${negative}${minutesPlace}:${padZero(secondsPlace)}`;
   }

   return `${negative}00:${padZero(secondsPlace)}`;
};

const formatTimeForSpeech = (totalSeconds: number): string => {
   const negative = totalSeconds < 0 ? '-' : '';
   const roundedTotalSeconds = negative ? Math.round(totalSeconds * -1) : Math.round(totalSeconds);
   // eslint-disable-next-line @typescript-eslint/no-magic-numbers
   return Math.floor(roundedTotalSeconds) === 0 ? '0 seconds' : new Date(roundedTotalSeconds * 1000).toISOString().substr(11, 8);
};

const getRoundedTime = (time: number): number => Math.floor(time * 1000) / 1000;

const getSecondsFromTimeString = (time: string): number => {
   const timecodeDelimiter = ':';
   const maxSupportTimecodePlaces = 3;
   const secondsMultiplier = 60;
   let timeInSeconds = 0;
   let multiplier = 1;
   const timecodeParts = time.split(timecodeDelimiter);
   const lowTimeBounds = timecodeParts.length > maxSupportTimecodePlaces ? timecodeParts.length - maxSupportTimecodePlaces : 0;

   for (let i = timecodeParts.length - 1; i >= lowTimeBounds; i--) {
      const timePartAsNumber = parseInt(timecodeParts[i], 10);
      if (!isNaN(timePartAsNumber)) {
         timeInSeconds += timePartAsNumber * multiplier;
      }
      multiplier *= secondsMultiplier;
   }

   return timeInSeconds;
};

// convert milliseconds to hh:mm:ss format with hh being included only if necessary
const millisecondsToFormattedTimeString = (milliseconds: number): string => {
   const seconds = Math.round(milliseconds / 1000);
   const hours = Math.floor(seconds / secondsInHour);
   const minutes = Math.floor((seconds - (hours * secondsInHour)) / secondsInMinute);
   const remainingSeconds = seconds - (hours * secondsInHour) - (minutes * secondsInMinute);
   return `${hours ? `${hours}:` : ''}${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export default {
   formatTime,
   formatTimeForSpeech,
   getRoundedTime,
   getSecondsFromTimeString,
   millisecondsToFormattedTimeString
};
